import { useForm } from "react-hook-form";

const useSearchForm = () => {
  return useForm<{
    keyword: string;
    tags: string[];
    only_bookmarked: string;
  }>({
    defaultValues: {
      keyword: "",
      tags: [],
      only_bookmarked: "0",
    },
  });
};

export default useSearchForm;
